<template>
  <transition mode="out-in">
    <v-row class="fill-height" align="center" justify="center" v-if="!pageContentObject" key="loading">
      <v-col cols="auto" class="shrink" >
        <loading-sphere />
      </v-col>
    </v-row>
    <MomentumScrolling
      v-else
      key="details"
    >
      <template v-slot="{ momentum }">
        <portal to="spotify-icon" >
          <spotify-icon v-if="pageContentObject.spotifyLabel && pageContentObject.spotifyURL" :label="pageContentObject.spotifyLabel" :link="pageContentObject.spotifyURL" />
        </portal>
        <portal to="back-button" >
           <v-btn v-if="GenericPage && GenericPage._referents.InitiativeReferents.totalCount > 0" text tile block exact :to="{ name: 'Initiatives', params: { initiative: GenericPage._referents.InitiativeReferents.items[0]._slug } }">{{$root.siteConfig.backButtonLabel}}</v-btn>
        </portal>
        <generic-hero-block
          :socials="pageContentObject.socials"
          :author="pageContentObject.author"
          :logo="pageContentObject.logo"
          :heroImage="pageContentObject.heroImage"
          :heroText="pageContentObject.heroText"
          :title="pageContentObject.title"
          :subtitle="pageContentObject.subtitle"
          />
        <component
          :is="blockComponents[block._repeaterType]"
          v-for="(block, i) in blocks"
          :key="i"
          :content="block"
          :momentum="momentum"
          :index="i"
          />
      </template>
    </MomentumScrolling>
  </transition>
</template>

<script>
import MomentumScrolling from '@/atoms/MomentumScrolling.vue'
import GetGenericPage from '@/graphql/GetGenericPage.gql'
import GenericHeroBlock from '@/molecules/GenericHeroBlock.vue'
import InitiativeVideo from '@/molecules/InitiativeVideo.vue'
import InitiativeGallery from '@/molecules/InitiativeGallery.vue'
import GenericStaggeredList from '@/molecules/GenericStaggeredList.vue'
import GenericListItemOffsetted from '@/molecules/GenericListItemOffsetted.vue'
import SpotifyIcon from '@/atoms/SpotifyIcon.vue'
import LoadingSphere from '@/atoms/LoadingSphere.vue'
import ContentParagraph from '@/molecules/ContentParagraph'

export default {
  components: {
    MomentumScrolling,
    GenericHeroBlock,
    SpotifyIcon,
    LoadingSphere
  },
  name: 'GenericPage',
  props: {
    slug: {
      type: String,
      required: false
    },
    contentData: {
      type: Object,
      required: false
    },
    staggeredListCols: {
      type: Number,
      required: false,
      default () {
        return 3
      }
    }
  },
  data () {
    return {
      blockComponents: {
        video: InitiativeVideo,
        gallery: InitiativeGallery,
        staggeredList: GenericStaggeredList,
        genericListItem: GenericListItemOffsetted,
        Paragraph: ContentParagraph
      }
    }
  },
  apollo: {
    GenericPage: {
      query: GetGenericPage,
      skip () {
        return !this.slug
      },
      variables () {
        return {
          slug: this.slug,
          variants: [this.$language.current === 'en' ? 'base' : this.$language.current],
          status: 'PUBLISHED'
        }
      },
      result ({ data }, key) {
        if (!data[key]) {
          this.$router.replace({ name: 'Home' })
        }
        this.$root.$emit('scroll-to-saved-position')
      }
    }
  },
  computed: {
    pageContentObject () {
      return this.contentData || this.GenericPage
    },
    blocks () {
      if (!this.pageContentObject || (this.pageContentObject && !this.pageContentObject.content)) return []
      const ret = []
      const staggeredListItems = []
      this.pageContentObject.content.forEach(block => {
        if (block._repeaterType === 'staggeredListItem') staggeredListItems.push(block)
        else ret.push(block)
      })
      if (staggeredListItems.length > 0) {
        ret.push({
          _repeaterType: 'staggeredList',
          cols: this.staggeredListCols,
          items: staggeredListItems
        })
      }
      return ret
    }
  },
  metaInfo () {
    return {
      // home page browser title
      title: this.pageContentObject ? this.pageContentObject.title : '...'
    }
  }
}
</script>
